export const COMPANY_DETAILS = '/business-name';
export const INDUSTRY = '/';
export const TAGS = '/tags';
export const PURPOSE = '/purpose';
export const NAMESLIST = '/names-list';
